import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { tryGetProp } from "../utils";

const appInsights = new ApplicationInsights({
	config: {
		instrumentationKey: tryGetProp("", () => window.pow.appInsightsKey),
	},
});

const telemetryInitializer = (envelope) => {
	envelope.data.environment = "Perficient.POW.UI";
};

try {
	appInsights.loadAppInsights();
	appInsights.addTelemetryInitializer(telemetryInitializer);
} catch (error) {
	console.log(`Could not initialize Application Insights - ${error}`);
}

export { appInsights };
